import React from "react";
import { Navigate, Route, Routes, useLocation } from "react-router-dom";

import Dashboard from "../student/Dashboard";
import StudentProfile from "../student/ProfilePage";
import MyCourses from "../student/MyCourses";
import CourseDetails from "../student/CourseDetails";
import TestDashboard from "../student/TestDashboard";
import Quiz from "../student/Quiz";
import TestResult from "../student/TestResult";

// Ye files jab ready ho jaye tab import uncomment kar dena
// import Certificates from "../student/Certificates";
// import LiveClasses from "../student/LiveClasses";
// import LiveClassRoom from "../student/LiveClassRoom";

const StudentRoutes: React.FC = () => {
  const location = useLocation();
  const token = localStorage.getItem("token");

  if (!token) {
    return (
      <Navigate
        to={`/login?redirect=${encodeURIComponent(location.pathname)}`}
        replace
      />
    );
  }

  return (
    <Routes>
      <Route index element={<Dashboard />} />
      <Route path="dashboard" element={<Dashboard />} />
      <Route path="profile" element={<StudentProfile />} />
      <Route path="my-courses" element={<MyCourses />} />
      <Route path="course/:courseId" element={<CourseDetails />} />

      <Route path="tests" element={<TestDashboard />} />
      <Route path="quiz/:testId" element={<Quiz />} />
      <Route path="test-result/:attemptId" element={<TestResult />} />

      {/* Temporary redirects for pages not ready yet */}
      <Route path="certificates" element={<Navigate to="/student-dashboard" replace />} />
      <Route path="live-classes" element={<Navigate to="/student-dashboard" replace />} />
      <Route path="live-class-room/:classId" element={<Navigate to="/student-dashboard" replace />} />

      <Route path="*" element={<Navigate to="/student-dashboard" replace />} />
    </Routes>
  );
};

export default StudentRoutes;
